import { LabelValueSet } from "../utility/LabelValueSet";

const FamilyDistanceType = Symbol();

export class FamilyDistance extends LabelValueSet {
    [FamilyDistanceType]: any;

    static fromNothing(): FamilyDistance {
        return なし;
    }
}

const なし = new FamilyDistance("なし", "なし");
const 近距離 = new FamilyDistance("近距離（車や電車で1時間以内）", "近距離");
const 遠距離 = new FamilyDistance("遠距離（車や電車で1時間以上）", "遠距離");

const mapValueToItem: { [key: string] : FamilyDistance} = {
    "なし": なし,
    "近距離": 近距離,
    "遠距離": 遠距離,
};

export const familyDistanceList: FamilyDistance[] = [
    なし,
    近距離,
    遠距離,
];

export const getFamilyDistanceFromValue = (value: string): FamilyDistance | undefined => {
    return mapValueToItem[value];
};
